<template>
  <select
    v-model="selectedItem"
    data-automation="change-os-select"
  >
    <option
      v-for="distro in distros"
      :key="distro.display"
      :value="distro.display"
    >
      {{ distroDisplay(distro) }}
    </option>
  </select>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'OsPicker',
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      selectedItem: this.value,
    }
  },
  computed: {
    ...mapState({
      distros: state => state.status.distros,
    }),
  },
  watch: {
    selectedItem: function (newValue, oldValue) {
      this.$emit('change', newValue)
    },
  },
  methods: {
    distroDisplay: function (distro) {
      if (!distro.binaries && distro.display !== 'macOS') {
        return distro.display + '*'
      }
      return distro.display
    },
  },
}

</script>
